<template>
  <div>
    <div class="row" style="align-items: center; margin-bottom: 0.5rem">
      <div class="col-8">
        <h3 style="margin: 0">{{ nome }}</h3>
      </div>
      <div class="col-4" style="text-align: right">
        <md-button
          v-if="epanetId"
          class="md-icon-button md-raised md-dense"
          style="margin-right: 4px"
          @click="$emit('show-epanet-node', epanetId)"
        >
          <md-icon>hub</md-icon>
          <md-tooltip md-direction="left">Ver nó EPANET</md-tooltip>
        </md-button>
        <md-button
          class="md-icon-button md-list-action"
          @click="$emit('close')"
        >
          <md-icon>close</md-icon>
          <md-tooltip md-direction="left">Fechar</md-tooltip>
        </md-button>
      </div>
    </div>

    <div class="row" style="align-items: center; margin-bottom: 1rem">
      <div class="col-12">
        <md-field style="border-bottom: none; margin: 0">
          <label for="filtro-rapido">Período</label>
          <md-select
            id="filtro-rapido"
            v-model="filtro.offset"
            name="filtro-rapido"
            @md-selected="fetchSensores"
          >
            <md-option :value="ms(30, 'min')">30 min</md-option>
            <md-option :value="ms(1, 'hora')">1 hora</md-option>
            <md-option :value="ms(2, 'hora')">2 horas</md-option>
            <md-option :value="ms(4, 'hora')">4 horas</md-option>
            <md-option :value="ms(8, 'hora')">8 horas</md-option>
            <md-option :value="ms(24, 'hora')">24 horas</md-option>
          </md-select>
        </md-field>
      </div>
    </div>

    <div v-if="loading" style="text-align: center; padding: 2rem">
      <md-progress-spinner
        :md-diameter="60"
        :md-stroke="5"
        md-mode="indeterminate"
      />
    </div>

    <div v-else-if="sensores !== null && sensores.length === 0 && !loading">
      <md-empty-state
        md-rounded
        md-icon="timeline"
        md-label="Sem dados"
        md-description="Não há dados de sensores para esse equipamento no período selecionado."
      />
    </div>

    <div v-else-if="sensores !== null">
      <div
        v-for="[tipo, data] in sensores"
        :key="tipo"
        class="col-12 p-0"
        style="margin-bottom: 1rem"
      >
        <graphic-area
          :sensores="data"
          :tipo="tipo"
          :range="filtro.range"
          :max-value="filtro.maxValue"
          height="250"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GraphicArea from '@/components/GraphicArea.vue'
import http from '@/utils/http'

export default {
  name: 'EpanetEquipamentoDrawer',
  components: { GraphicArea },
  props: {
    equipamentoId: {
      type: String,
      required: true,
    },
    nome: {
      type: String,
      default: '',
    },
    epanetId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      sensores: null,
      tiposSensores: {},
      filtro: {
        offset: 1000 * 60 * 60 * 2,
        range: 1000 * 60 * 60 * 2,
        maxValue: new Date().getTime(),
      },
    }
  },
  watch: {
    equipamentoId: {
      immediate: true,
      handler() {
        this.sensores = null
        this.fetchSensores()
      },
    },
  },
  async created() {
    const response = await http.get('tiposSensores', {}, false)
    if (response && response.tiposSensores) {
      this.tiposSensores = response.tiposSensores.reduce((acc, e) => {
        acc[e.tipo] = e
        return acc
      }, {})
    }
  },
  methods: {
    ms(n, unit) {
      switch (unit) {
        case 'min':
          return 1000 * 60 * n
        case 'hora':
          return 1000 * 60 * 60 * n
        default:
          return 0
      }
    },
    async fetchSensores() {
      if (!this.equipamentoId) return

      this.loading = true

      const periodoISO = new Date(
        new Date().getTime() - this.filtro.offset
      ).toISOString()

      this.filtro.range = this.filtro.offset
      this.filtro.maxValue = new Date().getTime()

      const response = await http.get(
        `equipamento/${this.equipamentoId}/sensores`,
        { periodo: periodoISO },
        false
      )

      if (!response) {
        this.loading = false
        return
      }

      let tipos = Object.keys(response.sensores)

      tipos = tipos.sort(
        (a, b) =>
          (this.tiposSensores[a]?.prioridade ?? 0) -
          (this.tiposSensores[b]?.prioridade ?? 0)
      )

      this.sensores = tipos.map((tipo) => [tipo, response.sensores[tipo]])

      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss"></style>
